import { render, staticRenderFns } from "./information-popup.vue?vue&type=template&id=7ea1228c"
import script from "./information-popup.vue?vue&type=script&lang=js"
export * from "./information-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports